import React, { useCallback, useMemo } from "react";
import Carousel from "../../../../../components/Carousel";
import CardArticle from "../../../../Dashboard/Posts/components/CardArticle";
import Grid from '../../../../../components/Grid'
import { connect, useDispatch } from "react-redux";
import CategoryListHeader from "../CategoryListHeader"
import {
  Title
} from './styles'
import { useWindowSize } from "../../../../../hooks/useWindowSize";
import { CategoryDto } from "../../../../../types/category";
import { Group } from "../../../../../types";
import { Line } from "../../../../Dashboard/components/Statistics/styles";

interface ComponentProps {
  group: Group
  allCategories: CategoryDto[]
}

const Component = ({
  group,
  allCategories,
}: ComponentProps) => {
  const { isMobile } = useWindowSize()
  const dispatch = useDispatch()

  const getLink = useCallback((category) => {
    return `/group/${group?.id}/p/c/${category?.id}`
  }, [group])

  const unlockedCategories = useMemo(() => {
    return allCategories
      ?.filter(item => item?.is_unlockable && item?.locked_ordinal !== undefined)
      ?.filter(item => item?.last_posts && item?.last_posts?.length > 0)
      ?.filter(item => !item?.user_access_data?.is_unlocked)
      ?.sort((a, b) => (a.locked_ordinal ?? Infinity) - (b.locked_ordinal ?? Infinity))
  }, [allCategories]);

  if (!unlockedCategories || unlockedCategories?.length <= 0) {
    return <></>
  }

  return (
    <>
      <Line />

      <div style={{ height: 40 }} />
      <Title>Contenido avanzado</Title>
      <div style={{ height: 40 }} />


      {unlockedCategories?.map((category: CategoryDto) => {
        if (category?.last_posts && category?.last_posts.length > 0) {
          return (
            <React.Fragment key={`unlocked-category-list-${category?.id}`}>
              <Grid.Row>
                <Grid.Col>
                  <CategoryListHeader category={category} />
                </Grid.Col>
              </Grid.Row>

              <div style={{ height: 26 }} />

              <Grid.Row>
                <Grid.Col>
                  <Carousel
                    items={category?.last_posts}
                    renderItem={(post, index) => (
                      <CardArticle
                        key={`unlocked-category-${category.id}-post-${post.id}`}
                        post={post}
                        groupInformation={group}
                        showPinAction={false}
                        blockedPost={true}
                      />
                    )}
                    slidesToShow={3}
                    scrollAmount={250}
                    animationSpeed={400}
                    showArrows={category?.last_posts?.length >= 4}
                    style={isMobile ? {
                      padding: "0px 0px 10px",
                      scrollSnapType: "x mandatory",
                      scrollPadding: "0px"
                    } : {}}
                  />
                </Grid.Col>
              </Grid.Row>

              <div style={{ height: 40 }} />
            </React.Fragment>
          )
        }

        return <React.Fragment key={`unlocked-category-list-${category?.id}`}></React.Fragment>
      })}
    </>
  )
};

const state = ({ categoryStore, groupStore }) => {
  const { data: allCategories } = categoryStore.allCategories;
  const { data: group } = groupStore.group;

  return {
    group,
    allCategories
  };
};

export default connect(state)(Component);
